import { createSelector } from 'reselect';
import { selectActiveVenueId } from 'selectors/general';
import { excessInventory as excessInventoryEntity } from 'store/saga/entities/bound';

export const selectExcessInventoryState = createSelector(
  (state, scheduleId) => ({ state, scheduleId }),
  selectActiveVenueId,
  ({ state, scheduleId }, venueId) => {
    const { weeksCount } = state.excessInventory;
    const key = excessInventoryEntity.defaultKey(null, { venueId, weeksCount, scheduleId });
    const { data, error, loading, loaded } = excessInventoryEntity.select(state, key);

    return {
      data,
      error,
      loading,
      loaded,
      weeksCount,
    };
  }
);
